<template>
  <div class="sites">
    <main>
      <section class="sites-intro">
          <h1>Edit Sites</h1>
          <button @click="showForm">+ Add New Site</button>
      </section>

      <section class="add-site" v-show="addNew === true">
        <h3>Add a Site</h3>
        <div>
          <label for="title">Studio or Business Name</label><br>
          <input v-model="title" type="text" id="title" name="title">
        </div>
        <div>
          <label for="logo">Logo URL (link to your logo)</label><br>
          <input v-model="logo" type="text" id="logo" name="logo">
        </div>
        <div>
          <label for="address">Address</label><br>
          <input v-model="address" type="text" id="address" name="address">
        </div>
        <div>
          <label for="city">City</label><br>
          <input v-model="city" type="text" id="city" name="city">
        </div>
        <div>
          <label for="state">State/Province</label><br>
          <input v-model="state" type="text" id="state" name="state">
        </div>
        <div>
          <label for="country">Country</label><br>
          <input v-model="country" type="text" id="country" name="country">
        </div>
        <div>
          <label for="phone">Phone Number</label><br>
          <input v-model="phone" type="text" id="phone" name="phone">
        </div>
        <div>
          <label for="url">Website URL (full URL)</label><br>
          <input v-model="url" type="text" id="url" name="url">
        </div>
        <div>
          <label for="email">Email Address</label><br>
          <input v-model="email" type="email" id="email" name="email">
        </div>
        <div>
          <label for="insta">Instagram (handle only, i.e. "mystudio")</label><br>
          <input v-model="insta" type="text" id="insta" name="insta">
        </div>
        <div>
          <label for="facebook">Facebook (handle only, i.e. "mystudio")</label><br>
          <input v-model="facebook" type="text" id="facebook" name="facebook">
        </div>
        <div>
          <input type="checkbox" v-model="demo" id="demo" name="demo" value="true"><label for="demo">Demo Center</label>
        </div>
        <div>
          <input type="checkbox" v-model="trainer" id="trainer" name="trainer" value="true"><label for="trainer">Teacher Trainer</label>
        </div>
        <input v-model="published" type="hidden" id="published" name="published">
        <button @click="addSite">Submit</button> <button @click="hideForm">Cancel</button>
        <div>
          <p v-if="error">A problem occurred and your site information couldn't be submitted.<br>Please try again later.</p>
          <p v-if="message">Your site information was submitted successfully.</p>
        </div>
      </section>

      <div
        v-if="message"
        class="alert"
        :class="{ error: error }"
        @click="closeMessage"
      >
        <p>{{ message }}</p>
      </div>

      <section class="sites-results">
        <div class="loading" v-if="loading">
          <img src="https://s3.amazonaws.com/s3.pilates.com/img/contrology-loader.gif" alt="Stay tuned"/>
        </div>
        <div class="sites-list">
          <site-card
            @delete-site="deleteSite"
            @update-site="updateSite"
            v-for="site in sites"
            :key="site._id"
            :site="site"
            :is-editing="false"
            class="site"
          />
        </div>
      </section>

    </main>
  </div>
</template>s

<script>
import ApiService from '@/js/ApiService.js';
import SiteCard from '@/components/SiteCard.vue';

export default {
  name: 'editsites',

  metaInfo: {
    title: "Edit",
    titleTemplate: "%s | Contrology | Balanced Body",
    meta: [
      {
        name: "robots",
        content: "noindex, nofollow"
      },
      {
        property: "og:image",
        content: "https://s3.amazonaws.com/s3.pilates.com/contrology/contrology-default.jpg"
      }
    ]
  },

  components: {
    SiteCard
  },

  data() {
    return {
      error: false,
      loading: false,
      message: null,
      sites: [],
      addNew: false,
      title: '',
      logo: '',
      address: '',
      city: '',
      state: '',
      country: '',
      phone: '',
      url: '',
      email: '',
      insta: '',
      facebook: '',
      demo: false,
      trainer: false,
      published: true
    }
  },

  created() {
    this.fetchSites();
  },

  methods: {
    fetchSites() {
      this.error = false;
      this.loading = true;
      ApiService.getSites()
      .then(response => {
        this.loading = false;
        this.sites = response.data;
      })
      .catch(error => {
        this.loading = false;
        this.error = true;
        this.message = error;
        console.error(error);
      })
    },

    addSite() {
      this.error = false;
      this.loading = true;
      ApiService.addSite({
        title: this.title,
        logo: this.logo,
        address: this.address,
        city: this.city,
        state: this.state,
        country: this.country,
        phone: this.phone,
        url: this.url,
        email: this.email,
        insta: this.insta,
        facebook: this.facebook,
        demo: this.demo,
        trainer: this.trainer,
        published: this.published
      })
      .then( () => {
        this.loading = false;
        this.message = "The site has been added. Please note the database might take a few minutes to reflect his change.";
      })
      .catch( error => {
        this.loading = false;
        this.error = true;
        this.message = error;
        console.log(error);
      })
      .then( () => {
        this.fetchSites();
        this.addNew = false;
        this.title = '';
        this.logo = '';
        this.address = '';
        this.city = '';
        this.state = '';
        this.country = '';
        this.phone = '';
        this.url = '';
        this.email = '';
        this.insta = '';
        this.facebook = '';
        this.demo = false;
        this.trainer = false;
      })
    },

    deleteSite(site) {
      this.error = false;
      this.loading = true;
      let resp = confirm("You're about to delete an event. Do you want to continue?");
      if ( resp === true) {
        ApiService.deleteSite(site._id)
        .then( () => {
          this.loading = false;
          this.message = "The site has been deleted. Please note the database might take a few minutes to reflect his change.";
        })
        .catch( error => {
          this.loading = false;
          this.error = true;
          this.message = error;
          console.error(error);
        })
        .then( () => {
          this.fetchSites();
        })
      } else {
        this.loading = false;
      }
    },

    updateSite(site) {
      this.error = false;
      this.loading = true;
      ApiService.updateSite(site._id, {
        title: site.title,
        logo: site.logo,
        address: site.address,
        city: site.city,
        state: site.state,
        country: site.country,
        phone: site.phone,
        url: site.url,
        email: site.email,
        insta: site.insta,
        facebook: site.facebook,
        demo: site.demo,
        trainer: site.trainer,
        published: site.published
      })
      .then( () => {
        this.loading = false;
        this.message = "The site has been updated. Please note the database might take a few minutes to reflect his change.";
      })
      .then( () => {
        this.fetchSites();
      })
      .catch( error => {
        this.loading = false;
        this.error = true;
        this.errorMessage = error;
        console.error(error);
      })
    },

    closeMessage() {
      this.error = false;
      this.message = '';
    },

    showForm() {
      this.addNew = true;
    },

    hideForm() {
      this.addNew = false;
    },
  }
}
</script>

<style lang="scss" scoped>
main {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
}

.loading {
  position: absolute;
  top: 30%;
  left: 50%;
}

.add-site {
  width: 100%;
  margin: 30px 0;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
}

.add-site > div {
  width: 100%;
  max-width: 400px;
}

.sites-results {
  margin-top: 20px;
}

.sites-list {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
}

.alert {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 80%;
  margin: 0 auto;
  background-color: green;
  color: var(--white);
  padding: 5px 20px;
  border-radius: 0 0 5px 5px;
  font-size: 1.1rem;
  z-index: 2000;
}

.alert::after {
  content: "✕";
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 0;
  padding: 10px 15px;
}

.error {
  background-color: red;
}

button {
  width: 200px;
  height: 30px;
  font-size: 1em;
  margin-top: 10px;
  border-color: var(--black);
  background-color: var(--black);
  color: var(--white);
  transition: .2s;
  cursor: pointer;
}

button:hover {
  background-color: #808080;
}

label, p {
  font-family: var(--roboto);
  font-weight: 400;
  font-size: .875em;
  line-height: 1.614;
}

input {
  border: 1px solid #5f6062;
  padding: 10px;
  width: 100%;
  max-width: 400px;
  font-size: 1em;
}

input[type="checkbox"] {
  display: inline-block;
  position: relative;
  border: 1px solid var(--black);
  color: #666;
  top: 10px;
  height: 30px;
  width: 30px;
  border-radius: 0;
  cursor: pointer;
  margin-right: 7px;
  outline: none;
  appearance: none;
  background-color: var(--white);
}

input[type="checkbox"]:checked {
  background-size: 15px 14px;
}

input[type="checkbox"]:checked::before {
  position: absolute;
  font: 13px/1 var(--roboto);
  left: 11px;
  top: 7px;
  content: '\02143';
  transform: rotate(40deg);
}
</style>